export default __webpack_public_path__ + "static/media/Unholy Skullsplitter.b5720188.jpg";